import type { RootState } from '../CreateStore'

export const selectHistoryState = (state: RootState) => state.history
